import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface ContactInformationPreviewItemProps {
    label: string;
    title: string;
    prefix?: ReactNode;
}

const ContactInformationPreviewItem = ({ label, title, prefix }: ContactInformationPreviewItemProps) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '16px' }}>
            <Typography
                variant='h3'
                sx={{
                    color: 'common.black',
                    fontSize: '16px',
                    fontWeight: '400',
                }}
            >
                {label}
            </Typography>
            <Typography
                variant='h4'
                sx={{
                    color: 'common.grey1',
                    fontSize: '14px',
                    fontWeight: '400',
                    display: 'flex',
                    gap: '8px',
                    alignItems: 'center',
                }}
            >
                {title ? (
                    <>
                        {prefix && prefix}
                        {title}
                    </>
                ) : (
                    'N/A'
                )}
            </Typography>
        </Box>
    );
};

export default ContactInformationPreviewItem;
